import VolmaTable from "./ExperimentalVolmaTable"

export default VolmaTable;